export default __webpack_public_path__ + "static/product-unit-19-emergency-3d27f12a5bc6d2dab47e6d745cd77aa8.png";